import { render, staticRenderFns } from "./NotFoundPage.vue?vue&type=template&id=1dada1dc&scoped=true&lang=html&"
import script from "./NotFoundPage.vue?vue&type=script&lang=js&"
export * from "./NotFoundPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dada1dc",
  null
  
)

export default component.exports